module.exports = __webpack_public_path__ + "images/botenwacht59823c4c716b4731bc9e2f196bebdddf.png";